'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELAYED_REPORT_TYPES = exports.REPORT_REASONS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _video = require('../constants/events/video');

var _video2 = _interopRequireDefault(_video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var REPORT_REASONS = exports.REPORT_REASONS = {
  LONG_INITIAL_VIDEO_PARTS_LOADING: 'long-initial-video-parts-loading',
  LONG_METADATA_LOADING: 'long-metadata-loading',
  LONG_SEEK_PROCESSING: 'long-seek-processing',
  BUFFER_EMPTY_FOR_CURRENT_SEGMENT: 'buffer-empty-for-current-segment',
  LONG_PLAY_REQUESTED_PROCESSING: 'long-play-requested-processing'
};

var DELAYED_REPORT_TYPES = exports.DELAYED_REPORT_TYPES = {
  INITIAL_VIDEO_PARTS_LOADING: { id: '_initialVideoPartsLoading', timeoutTime: 2000 },
  METADATA_LOADING: { id: '_metadataLoading', timeoutTime: 2000 },
  RUNTIME_LOADING: { id: '_runtimeLoading', timeoutTime: 2000 }
};

var AnomalyBloodhound = function () {
  function AnomalyBloodhound(_ref) {
    var engine = _ref.engine,
        eventEmitter = _ref.eventEmitter,
        config = _ref.config;

    _classCallCheck(this, AnomalyBloodhound);

    this._config = config;
    this._engine = engine;
    this._eventEmitter = eventEmitter;

    this._timeoutContainer = Object.create(null);

    this._bindEvents();
  }

  _createClass(AnomalyBloodhound, [{
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_video2.default.STATE_CHANGED, this._processStateChange, this);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_video2.default.STATE_CHANGED, this._processStateChange, this);
    }
  }, {
    key: '_processStateChange',
    value: function _processStateChange(_ref2) {
      var prevState = _ref2.prevState,
          nextState = _ref2.nextState;
      var STATES = this._engine.STATES;


      switch (nextState) {
        case STATES.LOAD_STARTED:
          if (this._engine.getAutoPlay() || this._engine.getPreload() !== 'none') {
            this.startDelayedReport(DELAYED_REPORT_TYPES.METADATA_LOADING, REPORT_REASONS.LONG_METADATA_LOADING);
          }
          break;

        case STATES.METADATA_LOADED:
          if (this.isDelayedReportExist(DELAYED_REPORT_TYPES.METADATA_LOADING)) {
            this.stopDelayedReport(DELAYED_REPORT_TYPES.METADATA_LOADING);

            if (this._engine.getPreload() !== 'metadata') {
              this.startDelayedReport(DELAYED_REPORT_TYPES.INITIAL_VIDEO_PARTS_LOADING, REPORT_REASONS.LONG_INITIAL_VIDEO_PARTS_LOADING);
            }
          }
          break;

        case STATES.READY_TO_PLAY:
          if (this.isDelayedReportExist(DELAYED_REPORT_TYPES.INITIAL_VIDEO_PARTS_LOADING)) {
            this.stopDelayedReport(DELAYED_REPORT_TYPES.INITIAL_VIDEO_PARTS_LOADING);
          }
          if (this.isDelayedReportExist(DELAYED_REPORT_TYPES.RUNTIME_LOADING)) {
            this.stopDelayedReport(DELAYED_REPORT_TYPES.RUNTIME_LOADING);
          }
          break;

        case STATES.SEEK_STARTED:
          if (prevState === STATES.PAUSED) {
            this.startDelayedReport(DELAYED_REPORT_TYPES.RUNTIME_LOADING, REPORT_REASONS.LONG_SEEK_PROCESSING);
          }
          break;

        case STATES.WAITING:
          switch (prevState) {
            case STATES.PLAYING:
              this.reportDebugInfo({ reason: REPORT_REASONS.BUFFER_EMPTY_FOR_CURRENT_SEGMENT });
              break;

            case STATES.PLAY_REQUESTED:
              if (!this.isDelayedReportExist(DELAYED_REPORT_TYPES.RUNTIME_LOADING)) {
                this.startDelayedReport(DELAYED_REPORT_TYPES.RUNTIME_LOADING, REPORT_REASONS.LONG_PLAY_REQUESTED_PROCESSING);
              }
              break;

            default:
              break;
          }
          break;

        default:
          break;
      }
    }
  }, {
    key: 'isDelayedReportExist',
    value: function isDelayedReportExist(type) {
      return Boolean(this._timeoutContainer[type.id]);
    }
  }, {
    key: 'startDelayedReport',
    value: function startDelayedReport(type, reason) {
      var _this = this;

      if (this.isDelayedReportExist(type)) {
        this.stopDelayedReport(type);
      }

      var startTS = Date.now();
      this._timeoutContainer[type.id] = setTimeout(function () {
        var endTS = Date.now();
        _this._timeoutContainer[type.id] = null;
        _this.reportDebugInfo({
          reason: reason,
          startTS: startTS,
          endTS: endTS
        });
      }, type.timeoutTime);
    }
  }, {
    key: 'stopDelayedReport',
    value: function stopDelayedReport(type) {
      clearTimeout(this._timeoutContainer[type.id]);
      this._timeoutContainer[type.id] = null;
    }
  }, {
    key: 'stopAllDelayedReports',
    value: function stopAllDelayedReports() {
      var _this2 = this;

      Object.keys(this._timeoutContainer).forEach(function (key) {
        clearTimeout(_this2._timeoutContainer[key]);
        _this2._timeoutContainer[key] = null;
      });
    }
  }, {
    key: 'reportDebugInfo',
    value: function reportDebugInfo(_ref3) {
      var reason = _ref3.reason,
          startTS = _ref3.startTS,
          endTS = _ref3.endTS;

      if (typeof this._config.callback === 'function') {
        this._config.callback(_extends({
          reason: reason,
          startTS: startTS,
          endTS: endTS
        }, this._engine.getDebugInfo()));
      } else {
        console.log( // eslint-disable-line no-console
        'REASON: ' + reason + '; startTS: ' + startTS + '; endTS: ' + endTS, this._engine.getDebugInfo());
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.stopAllDelayedReports();

      this._unbindEvents();

      delete this._eventEmitter;
      delete this._engine;
      delete this._timeoutContainer;
      delete this._config;
    }
  }]);

  return AnomalyBloodhound;
}();

exports.default = AnomalyBloodhound;
//# sourceMappingURL=anomaly-bloodhound.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/anomaly-bloodhound/anomaly-bloodhound.js
// module id = 1222
// module chunks = 1 2 3